import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormHelperText } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import OfferPartnerContactPersonsDataRowComponent from './OfferPartnerContactPersonsDataRowComponent';
import { isValid } from '@totalsoft/pure-validations-react';
import { withRights } from 'providers/RightsConsumer';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { GapGrid, GridActionsWrapper } from 'components/common/CommonStyles';

export const OfferPartnerContactPersonsListComponent = ({
  contactPersonList,
  positions,
  saveContactPersons,
  addContactPerson,
  deleteContactPerson,
  onPropertyChange,
  openMasterPartner,
  openDocumentPartner,
  masterPartnerApp,
  t,
  loadPersons,
  partnerId,
  saveDisabled,
  validation,
  validDefaultContactPerson,
  loadPartnerDetails,
  clientContactinfoWrite,
  rights,
  onContactPersonClear,
  showESignatureCheckboxFromContactPersonsCard,
  isAssociatedPartner,
  saving
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <CardNoResultsWrapper content={contactPersonList}>
          <GapGrid gap={1}>
            {contactPersonList.map((document, idx) => {
              return (
                <OfferPartnerContactPersonsDataRowComponent
                  key={idx}
                  idx={idx}
                  contactPerson={document}
                  positions={positions}
                  deleteContactPerson={() => deleteContactPerson(document)}
                  openMasterPartner={openMasterPartner}
                  openDocumentPartner={openDocumentPartner}
                  masterPartnerApp={masterPartnerApp}
                  validation={validation[idx]}
                  onPropertyChange={onPropertyChange(idx)}
                  loadPersons={loadPersons}
                  loadPartnerDetails={loadPartnerDetails}
                  clientContactinfoWrite={clientContactinfoWrite}
                  onContactPersonClear={() => onContactPersonClear(idx)}
                  showESignatureCheckboxFromContactPersonsCard={showESignatureCheckboxFromContactPersonsCard}
                  isAssociatedPartner={isAssociatedPartner}
                />
              );
            })}
          </GapGrid>
        </CardNoResultsWrapper>

        {!validDefaultContactPerson && (
          <FormHelperText error={true} id='name-error-text'>
            {t('OfferEdit.Client.ContactPersons.ValidateUniqueDefaultContactPerson')}
          </FormHelperText>
        )}
        <GridActionsWrapper mt={2}>
          <Button
            id={'offerPartnerContactPersonsCard_addBtn'}
            onClick={addContactPerson}
            disabled={rights.readOnlyFull || !clientContactinfoWrite}
          >
            {t('Add')}
          </Button>
          <Button
            id={'offerPartnerContactPersonsCard_saveBtn'}
            onClick={() => saveContactPersons(partnerId, contactPersonList)}
            disabled={rights.readOnlyFull || saveDisabled || !isValid(validation) || !clientContactinfoWrite || saving}
          >
            {saving ? t('Saving') : t('Save')}
          </Button>
        </GridActionsWrapper>
      </Grid>
    </Grid>
  );
};

OfferPartnerContactPersonsListComponent.propTypes = {
  contactPersonList: PropTypes.array.isRequired,
  positions: PropTypes.array.isRequired,
  addContactPerson: PropTypes.func.isRequired,
  openMasterPartner: PropTypes.func.isRequired,
  openDocumentPartner: PropTypes.func.isRequired,
  masterPartnerApp: PropTypes.bool,
  saveContactPersons: PropTypes.func.isRequired,
  deleteContactPerson: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  loadPersons: PropTypes.func.isRequired,
  partnerId: PropTypes.number,
  validation: PropTypes.object.isRequired,
  saveDisabled: PropTypes.bool,
  validDefaultContactPerson: PropTypes.bool,
  loadPartnerDetails: PropTypes.func,
  clientContactinfoWrite: PropTypes.bool.isRequired,
  rights: PropTypes.object.isRequired,
  onContactPersonClear: PropTypes.func.isRequired,
  showESignatureCheckboxFromContactPersonsCard: PropTypes.bool.isRequired,
  isAssociatedPartner: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired
};
export default withTranslation()(withRights(OfferPartnerContactPersonsListComponent));
